import { useEffect, useState } from 'react'
import { WellHeadSecurityFieldsView } from '../../../../../types/form-types'
import NotesWrapperView from '../../../../components/well-forms/notes/notes-wrapper-view'
import WellheadSecurityViewConstruction from '../../../../components/well-forms/wellhead-security/well-head-security-view-construction'
import WellheadSecurityViewQuality from '../../../../components/well-forms/wellhead-security/well-head-security-view-quality'
import WellheadSecurityViewSurroundingArea from '../../../../components/well-forms/wellhead-security/well-head-security-view-surrounding-area'
import WellViewButtons from '../../../../components/wells/well-view-buttons'
import { useGetWellData } from '../../../../hooks/use-api'
import { useWellId } from '../../../../hooks/use-well-id'
import { Divider, Heading, RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'

export default function ViewWellHeadSecurity() {
  useTitleChange('View Well | Wellhead Security')

  const [fields, setFields] = useState<Partial<WellHeadSecurityFieldsView>>({})
  const id = useWellId()
  const url = `wells/${id}/wellhead-security/view`
  const { isLoading, isSuccess, data } = useGetWellData(url)

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  return (
    <>
      <RecordContent>
        <Heading isSkeleton={isLoading} level={2}>
          Wellhead security
        </Heading>

        <WellheadSecurityViewQuality isLoading={isLoading} fields={fields} />

        <Divider />

        <WellheadSecurityViewConstruction isLoading={isLoading} fields={fields} />

        <Divider />

        <WellheadSecurityViewSurroundingArea isLoading={isLoading} fields={fields} />
      </RecordContent>
      <RecordFooter
        notes={
          Array.isArray(fields.notes) &&
          !!fields.notes.length && <NotesWrapperView notes={fields.notes} isLoading={isLoading} />
        }
        areActionsFixed={true}
      >
        <WellViewButtons wellId={id} />
      </RecordFooter>
    </>
  )
}
